import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import BackButton from "@/components/BackButton";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="space-y-8 slide-up" data-testid="notifications-page">
      <BackButton />
      <header>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-2">Inbox</div>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl uppercase font-bold tracking-tight">Notifications</h1>
      </header>
      <div className="border border-border rounded-sm bg-surface divide-y divide-border">
        {items.length === 0 && <div className="p-8 text-sm text-muted-foreground text-center">All caught up.</div>}
        {items.map((n) => (
          <button
            key={n.id}
            onClick={() => n.link && nav(n.link)}
            className="w-full text-left px-6 py-4 hover:bg-surface-elev transition"
            data-testid={`notif-${n.id}`}
          >
            <div className="flex items-center gap-2 mb-1">
              <span className={`px-1.5 py-0.5 rounded-sm text-[9px] font-mono uppercase tracking-widest ${n.category === "asset" ? "strain-indica" : n.category === "request" ? "strain-sativa" : "bg-surface-elev"}`}>{n.category}</span>
              <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{new Date(n.created_at).toLocaleString()}</span>
            </div>
            <div className="font-semibold">{n.title}</div>
            <div className="text-sm text-muted-foreground mt-0.5">{n.body}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
